var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"search-item"},[_c('md-field',{staticClass:"search-input"},[_c('md-input',{attrs:{"placeholder":"Search"},on:{"input":_vm.searchGroups},model:{value:(_vm.searchGroupQuery),callback:function ($$v) {_vm.searchGroupQuery=$$v},expression:"searchGroupQuery"}}),_c('md-icon',[_vm._v("search")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }